/**
 * Where something went wrong (a join, a game that won't load, a dropped room): a way to tell us,
 * in this tab, so the contact form can offer to attach the last two minutes (P3-OBS-06).
 */
export function TellUs() {
  return (
    <p class="hint">
      Keeps happening? <a href="/contact#game">Tell us what happened</a>.
    </p>
  );
}
